import { z } from 'zod';

/** 빈 문자열은 "설정 안 함"으로 본다 (.env 에 키만 두고 값을 비운 경우) */
const optionalString = z
  .string()
  .optional()
  .transform(value => value?.trim() ?? '');

const envSchema = z.object({
  VITE_API_ORIGIN: optionalString.transform(value => value.replace(/\/+$/, '')),
  VITE_ASSET_BASE_URL: optionalString.transform(value => value.replace(/\/+$/, '')),
  VITE_GOOGLE_CLIENT_ID: optionalString,
  VITE_APPLE_CLIENT_ID: optionalString,
  VITE_APPLE_REDIRECT_URI: optionalString,
  VITE_API_MOCKING: optionalString.transform(value => value === 'true'),
});

const parsed = envSchema.parse(import.meta.env);

/**
 * 빌드 시점 환경 변수 — 값의 의미는 .env.example 참고.
 * 애플 로그인은 Service ID 와 Return URL 이 둘 다 있어야 켠다.
 */
export const env = {
  apiOrigin: parsed.VITE_API_ORIGIN,
  assetBaseUrl: parsed.VITE_ASSET_BASE_URL,
  googleClientId: parsed.VITE_GOOGLE_CLIENT_ID,
  appleClientId: parsed.VITE_APPLE_CLIENT_ID,
  appleRedirectUri: parsed.VITE_APPLE_REDIRECT_URI,
  apiMocking: parsed.VITE_API_MOCKING,
  isGoogleLoginEnabled: parsed.VITE_GOOGLE_CLIENT_ID !== '',
  isAppleLoginEnabled: parsed.VITE_APPLE_CLIENT_ID !== '' && parsed.VITE_APPLE_REDIRECT_URI !== '',
} as const;
